// extracted by mini-css-extract-plugin
module.exports =  {"pill":"KpDJjrf6","centered":"R1QhsB4t"};